import React from 'react';
import ReactDOM from "react-dom/client";
import Router from './routes/Router';
import './index.scss';
import './css/fonts/fonts.scss';
import axios from 'axios';
import { fixEncoding } from './utils/fixEncoding';


// Funzione per correggere ricorsivamente tutti i dati
const fixDataEncoding = (data) => {
    if (!data) return data;
    if (typeof data === 'string') return fixEncoding(data);
    if (Array.isArray(data)) return data.map(item => fixDataEncoding(item));
    if (typeof data === 'object') {
        const result = {};
        for (const key in data) {
            result[key] = fixDataEncoding(data[key]);
        }
        return result;
    }
    return data;
};

// INTERCEPTOR PER IL TOKEN
axios.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem('access_token');
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
    },
    (error) => Promise.reject(error)
);

axios.defaults.withCredentials = true;

// Interceptor per correggere la codifica delle risposte
axios.interceptors.response.use(
    (response) => {
        if (response.data) {
            response.data = fixDataEncoding(response.data);
        }
        return response;
    },
    async (error) => {
        const originalRequest = error.config;
        if (error.response?.status === 401 && !originalRequest._retry) {
            originalRequest._retry = true;
            try {
                await axios.post('/api/auth/refresh');
                return axios(originalRequest);
            } catch (refreshError) {
                window.location.href = '/';
                return Promise.reject(refreshError);
            }
        }
        return Promise.reject(error);
    }
);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<Router/>);
